import { useState } from 'react'
import { Button } from '../../components/ui'
import { formatDateInput } from '../../lib/format'

function ExpenseForm({ products, categories, onSubmit, onCancel, loading }) {
  const [formData, setFormData] = useState({
    date: formatDateInput(new Date().toISOString()),
    amount: '',
    category: categories[0],
    product_id: products[0]?.id || '',
    vendor: '',
    notes: '',
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!formData.date || !formData.amount || !formData.product_id) return
    onSubmit({
      ...formData,
      amount: Number(formData.amount),
      vendor: formData.vendor || null,
      notes: formData.notes || null,
    })
  }

  return (
    <form onSubmit={handleSubmit} className="stack">
      <div className="form-group">
        <label className="form-label">Date</label>
        <input
          className="form-input"
          type="date"
          name="date"
          value={formData.date}
          onChange={handleChange}
          required
        />
      </div>

      <div className="form-group">
        <label className="form-label">Amount</label>
        <input
          className="form-input"
          type="number"
          step="0.01"
          name="amount"
          value={formData.amount}
          onChange={handleChange}
          placeholder="1200"
          required
        />
      </div>

      <div className="form-group">
        <label className="form-label">Category</label>
        <select
          className="form-select"
          name="category"
          value={formData.category}
          onChange={handleChange}
        >
          {categories.map(category => (
            <option key={category} value={category}>{category}</option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label className="form-label">Product</label>
        <select
          className="form-select"
          name="product_id"
          value={formData.product_id}
          onChange={handleChange}
          required
        >
          <option value="">Select product</option>
          {products.map(product => (
            <option key={product.id} value={product.id}>{product.name}</option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label className="form-label">Vendor</label>
        <input
          className="form-input"
          name="vendor"
          value={formData.vendor}
          onChange={handleChange}
          placeholder="AWS"
        />
      </div>

      <div className="form-group">
        <label className="form-label">Notes</label>
        <textarea
          className="form-input"
          name="notes"
          value={formData.notes}
          onChange={handleChange}
          placeholder="Quarterly subscription"
          rows={3}
        />
      </div>

      <div className="modal-actions">
        <Button type="button" variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit" loading={loading}>
          Add Expense
        </Button>
      </div>
    </form>
  )
}

export default ExpenseForm
